module.exports = __webpack_public_path__ + "static/c3-bffd4969c9bd89c4b484e1cf3a92c831.jpg";